import { useQuery } from "@tanstack/react-query";
import api from "../../api/axios";

type DocumentType = {
  docTypeId: number;
  nombre: string;
  needsSignature: boolean;
  signaturePage: number | null;
  signatureX: number | null;
  signatureY: number | null;
};

export function useDocumentTypes() {
  return useQuery({
    queryKey: ["document-types"],
    queryFn: async (): Promise<DocumentType[]> => {
      const { data } = await api.get("/document-types");
      return data;
    },
    staleTime: 10 * 60 * 1000, // 10 min
  });
}
